import { useMutation } from '@apollo/client/react';
import { Button, Form, Input, Modal } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../AppContext';
import { GA_EVENT, GA_LABEL } from '../../common/constants';
import { Event } from '../../common/trackEvents';
import { formValidatorRules } from '../../common/utils';
import { DUPLICATE_EQC_TYPE } from './graphql/Mutation';

const { required, characterWithoutWhiteSpace } = formValidatorRules;

const DuplicateModal = (props) => {
  const {
    showModal,
    setShowModal,
    eqcData,
    setEqcData,
    refetchEqcDataWithInitialValues,
  } = props;
  const { getCurrentUser } = useContext(AppContext);
  const currentUser = getCurrentUser();
  const [form] = Form.useForm();

  const handleCancel = () => {
    setShowModal(false);
    form.resetFields();
  };

  const [duplicateEqc, { loading }] = useMutation(DUPLICATE_EQC_TYPE, {
    onError() {},
    onCompleted() {
      Event(GA_EVENT.DUPLICATE_GLOBAL_CHECKLIST, {
        label: GA_LABEL.DUPLICATE_GLOBAL_CHECKLIST,
        // eslint-disable-next-line no-undef
        pathname: window?.location?.href,
        checklist_id: eqcData?.id,
        user_id: currentUser?.id,
        user_name: currentUser?.name,
        tenant_id: currentUser?.tenantUser?.tenant?.id,
        tenant_name: currentUser?.tenantUser?.tenant?.organizationName,
      });
      setEqcData();
      form.resetFields();
      setShowModal(false);
      refetchEqcDataWithInitialValues();
    },
  });

  const onFinish = async (formValues) => {
    const newFormValues = {
      name: formValues?.name,
    };

    const variables = { eqcTypeId: eqcData.id, ...newFormValues };

    try {
      await duplicateEqc({
        variables: { data: { ...variables } },
      });
    } catch (error) {
      return error;
    }
  };

  return (
    <Modal
      id="duplicate-checklist-modal"
      maskClosable={false}
      centered
      open={showModal}
      className="dialog"
      footer={null}
      closable={false}
    >
      <h2 id="duplicate-eqc-modal-title">Duplicate Checklist</h2>
      <Form
        id="duplicate-eqc-form"
        form={form}
        initialValues={null}
        layout="vertical"
        onFinish={onFinish}
      >
        <Form.Item
          rules={[
            required,
            characterWithoutWhiteSpace,
            {
              max: 250,
              message: 'Name cannot be more than 250 characters',
            },
          ]}
          name="name"
          label="Name"
        >
          <Input
            id="checklist-name-input"
            allowClear
            placeholder="Enter Name"
          />
        </Form.Item>
        <div className="form-buttons">
          <Button
            id="duplicate-checklist-cancel-button"
            shape="round"
            className="cancel-button"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            id="duplicate-checklist-save-button"
            shape="round"
            type="primary"
            className="save-button"
            loading={loading}
            htmlType="submit"
          >
            Save
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default DuplicateModal;
